import React, { Fragment, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

import { markAsCompletedAction } from '../../redux/actions/orderActions';

const SingleOrderButtons = ({ order, user }) => {






    const dispatch = useDispatch();
    const { message } = useSelector(state => state.order)


    const [showPopup, setShowPopup] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);


    const [copied, setCopied] = useState(false);

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };














    const handleDispatch = () => {


        dispatch(markAsCompletedAction({ order_id: order?.id }))

    }





    useEffect(() => {
        if (message) {
            setShowPopup(false);
        }
    }, [message])

    return (
        <Fragment>
            <div className="flex justify-center flex-[1] items-center relative" ref={dropdownRef}>
                <button 
                    onClick={() => setShowDropdown(!showDropdown)}
                    className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.75vmax] font-bold transition-colors text-white flex items-center gap-1 
                        ${order?.status === "COMMISSIONED" ? "bg-emerald-600 hover:bg-emerald-700" :
                          order?.status === "COMPLETED" ? "bg-purple-600 hover:bg-purple-700" : 
                          "bg-amber-600 hover:bg-amber-700"}`}
                >
                    {order?.status === "COMMISSIONED" ? "Commissioned" :
                     order?.status === "COMPLETED" ? "Completed" : "Pending"}
                    <i className="fa-solid fa-chevron-down text-xs"></i>
                </button>
                
                {showDropdown && (
                    <div className="absolute right-0 top-full mt-1 w-[170px] bg-white border border-gray-100 shadow-lg rounded-lg z-[10] overflow-hidden">
                        <Link 
                            to={`/orders/order-details?order_id=${order?.id}`} 
                            className="flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium"
                            onClick={() => setShowDropdown(false)}
                        >
                            <i className="fa-regular fa-eye mr-2 w-4"></i> View
                        </Link>
                        
                        {(user?.role === "SUPER_ADMIN" || user?.role === "ADMIN") && (
                            <button 
                                className="flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium"
                                onClick={() => {
                                    setShowDropdown(false)
                                    setShowPopup(true)
                                }}
                            >
                                <i className="fa-solid fa-circle-check mr-2 w-4"></i> Mark Completed
                            </button>
                        )}
                        
                        {(user?.role === "SUPER_ADMIN" || user?.role === "ADMIN") && (
                            <button 
                                className="flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium"
                                onClick={() => {
                                    setShowDropdown(false)
                                    setViewDetails(true)
                                }}
                            >
                                <i className="fa-solid fa-building-columns mr-2 w-4"></i> Account Details
                            </button>
                        )}
                    </div>
                )}
            </div>

            {showPopup && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">
                        
                        {/* Icon */}
                        <div className="mx-auto w-12 h-12 rounded-full bg-indigo-50 text-indigo-600 flex-center text-2xl mb-4">
                            <i className="fa-solid fa-circle-question"></i>
                        </div>

                        {/* Content */}
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-2">
                                Mark Order as Completed
                            </h3>
                            <p className="text-sm text-zinc-500 leading-relaxed">
                                By completing this order, you confirm that the PM commission of
                                <strong className="text-zinc-800 font-bold">&nbsp;Rs. {order?.pm_commission_amount}&nbsp;</strong>
                                and the portal commission of <strong className="text-zinc-800 font-bold">&nbsp;Rs. {order?.portal_commission_amount}&nbsp;</strong> have been received, and the PM has been paid.
                            </p>
                            <p className="text-sm text-zinc-500 mt-2">Do you want to continue?</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-6">
                            <button
                                className="flex-1 text-zinc-600 font-semibold py-2.5 px-4 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]"
                                onClick={() => setShowPopup(false)}
                            >
                                No
                            </button>
                            <button
                                className="flex-1 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-semibold py-2.5 px-4 rounded-xl hover:shadow-lg hover:shadow-indigo-100 transition-all active:scale-[0.98]"
                                onClick={handleDispatch}
                            >
                                Yes, Complete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {viewDetails && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">
                        
                        {/* Icon */}
                        <div className="mx-auto w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex-center text-2xl mb-4">
                            <i className="fa-solid fa-building-columns"></i>
                        </div>

                        {/* Content */}
                        <div className="text-center mb-6">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-1">
                                PM Account Details
                            </h3>
                            <p className="text-sm text-zinc-400">Payment information for the order creator</p>
                        </div>

                        {/* Details Grid */}
                        <div className="grid grid-cols-1 gap-4">
                            <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-100">
                                <span className="text-xs font-bold text-zinc-400 uppercase tracking-wider">Account Holder Name</span>
                                <p className="text-base font-semibold text-zinc-800 mt-1">
                                    {order?.pm_account_title || <span className="text-zinc-300">N/A</span>}
                                </p>
                            </div>
                            
                            <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-100">
                                <span className="text-xs font-bold text-zinc-400 uppercase tracking-wider">Bank Name</span>
                                <p className="text-base font-semibold text-zinc-800 mt-1">
                                    {order?.pm_bank_name || <span className="text-zinc-300">N/A</span>}
                                </p>
                            </div>

                            <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-100 flex justify-between items-center">
                                <div>
                                    <span className="text-xs font-bold text-zinc-400 uppercase tracking-wider">Account Number</span>
                                    <p className="text-base font-semibold text-zinc-800 mt-1">
                                        {order?.pm_account_number || <span className="text-zinc-300">N/A</span>}
                                    </p>
                                </div>
                                {order?.pm_account_number && (
                                    <button
                                        onClick={() => handleCopy(order?.pm_account_number)}
                                        className={`w-10 h-10 rounded-lg flex-center transition-colors
                                            ${copied ? "bg-emerald-50 text-emerald-600" : "bg-white border border-zinc-200 text-zinc-500 hover:bg-zinc-50"}`}
                                        title={copied ? "Copied" : "Copy"}
                                    >
                                        <i className={`fa-regular ${copied ? "fa-circle-check" : "fa-copy"}`}></i>
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="mt-6">
                            <button
                                className="w-full bg-gradient-to-r from-zinc-700 to-zinc-800 text-white font-semibold py-2.5 px-4 rounded-xl hover:shadow-lg hover:shadow-zinc-100 transition-all active:scale-[0.98]"
                                onClick={() => setViewDetails(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SingleOrderButtons